import { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { FaUsers } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';

export default function Tiposidentificacion(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [tiposIdentificacion, setTiposIdentificacion] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <div className="btn-group">
                    <button type="button" className="btn btn-info" onClick={() => EditartipoIdentificacion(row)} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Editar">
                        <FaUsers/>
                    </button>
                </div>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
        { name: 'Tipo identificación', selector: row => row.tipTipoidentificacion, sortable: true, width: '25%'},
        { name: 'Descripcion', selector: row => row.tipDescripcion, sortable: true, width: '25%'},
        { name: 'Estado', selector: row => row.tipActivo?'Activo':'Inactivo', sortable: true, width: '7%' },
        { name: 'Estado registraduria', selector: row => row.tipActivoregistraduria?'Activo':'Inactivo', sortable: true, width: '7%' },
        { name: 'Estado extranjero', selector: row => row.tipActivoextranjero?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const url = '/parametros/tiposidentificacion';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setTiposIdentificacion(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function EditartipoIdentificacion (row){
        setMuestraFormulario(true);
        setValue('Nuevo', false);
        setValue('id', row.id);
        setValue('tipTipoidentificacion', row.tipTipoidentificacion);
        setValue('tipDescripcion', row.tipDescripcion);
        setValue('tipActivo', row.tipActivo);
        setValue('tipActivoregistraduria', row.tipActivoregistraduria);
        setValue('tipActivoextranjero', row.tipActivoextranjero);
    };
    const NuevoTipoIdentificacion = () =>  {
        setValue('Nuevo', true);
        setValue('id', 0);
        setValue('tipTipoidentificacion', '');
        setValue('tipDescripcion', '');
        setValue('tipActivo', false);
        setValue('tipActivoregistraduria', false);
        setValue('tipActivoextranjero', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardartipoidentificacion';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar tipo identificación', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar  tipo identificación', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar  tipo identificación', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('Nuevo', true);
        setValue('id', 0);
        setValue('tipTipoidentificacion', '');
        setValue('tipDescripcion', '');
        setValue('tipActivo', false);
        setValue('tipActivoregistraduria', false);
        setValue('tipActivoextranjero', false);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Tipos identificaci&oacute;n</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/parametros" >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Tipo identificación</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <input hidden {...register('Nuevo')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='tipTipoidentificacion'>Tipo identificaci&oacute;n</label>
                                                <input id='tipTipoidentificacion' {...register('tipTipoidentificacion', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Tipo identificación"/>
                                                {errors.tipTipoidentificacion && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='tipDescripcion'>Descripcion</label>
                                                <input id='tipDescripcion' {...register('tipDescripcion', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Descripcion"/>
                                                {errors.tipDescripcion && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('tipActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('tipActivoregistraduria')}
                                                    className="custom-control-input" id="SwitchEstadoReg"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstadoReg">Estado registraduria</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('tipActivoextranjero')}
                                                    className="custom-control-input" id="SwitchEstadoExt"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstadoExt">Estado extranjeria</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <button type="button" className='form-control' onClick={NuevoTipoIdentificacion}>Nuevo</button>
                                <DataTable
                                    title="Tipo identificación"
                                    columns={columns}
                                    data={tiposIdentificacion}
                                    progressPending={Cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}